export const TICKET_STATUS = [
  { label: "Open", value: "OPENED" },
  { label: "Resolved", value: "RESOLVED" },
  { label: "Closed", value: "CLOSED" },
  { label: "Reopen", value: "REOPENED" },
];
export const ENGINE_REPLACEMENT_STATUS = [
  {
    label: "Approved",
    value: "APPROVED",
  },
  { label: "Rejected", value: "REJECTED" },
];
